import { Component, ElementRef, OnInit, Input, ViewChild, ViewChildren, Query, QueryList } from '@angular/core';

import { Map, View, Feature } from "ol";
import { Group, Vector as VectorLayer } from "ol/layer";
import { XYZ, Vector as VectorSource, ImageWMS, TileArcGISRest } from "ol/source";
import { GeoJSON, WFS, WKT, WMSGetFeatureInfo } from "ol/format";
import { Circle, Fill, Stroke, Style,Icon } from "ol/style";
import { transform } from "ol/proj";
import TileLayer from "ol/layer/Tile";
import BingMaps from "ol/source/BingMaps";
import { defaults as defaultControls, ScaleLine } from "ol/control";
import { Draw, Modify, Snap } from "ol/interaction";
import GeometryType from 'ol/geom/GeometryType';
import {
  LineString,
  MultiLineString,
  MultiPoint,
  MultiPolygon,
  Point,
  Polygon,
} from 'ol/geom';
import LinearRing from 'ol/geom/LinearRing';

import * as shp from 'shpjs';
import * as jsts from 'jsts'
import { Chart } from 'chart.js';
import * as pallete from 'google-palette'

import { Router } from '@angular/router';
import { MapService } from "../../services/map.service";

import { NbStepperComponent, NbAccordionComponent } from "@nebular/theme";
import swal from 'sweetalert2'
import * as turf from '@turf/turf'
import Tabulator from 'tabulator-tables';
import TileWMS from "ol/source/TileWMS";
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-ecosistema-analisis',
  templateUrl: './ecosistema-analisis.component.html',
  styleUrls: ['./ecosistema-analisis.component.scss']
})
export class EcosistemaAnalisisComponent implements OnInit {

  constructor(private router: Router,private mapservice: MapService, private http: HttpClient) { }

  @Input() height: string = '311px';

  @ViewChild('stepper', {static:false}) stepper: NbStepperComponent;
  @ViewChild('steepercontainer', {static:false}) steepercontainer: ElementRef;
  @ViewChild('geomcontainer', {static:false}) geomcontainer: ElementRef;
  @ViewChild('Layercontainer', {static:false}) Layercontainer: ElementRef;
  @ViewChild('resultcontainer', {static:false}) resultcontainer: ElementRef;
  @ViewChild('accordionDash',{static:false}) accordionDash: NbAccordionComponent;
  @ViewChildren('canvas') canvas: any;
  @ViewChildren('table') table: any;
  
  public geojson_shp;
  private LayerBase;
  private  map;
  private mapa2;
  private draw;
  private vector;
  private source;
  private geojson_input;
  capas_select
  result_dataset = [];
  text_layers = [];
  chart=[];
  public context: CanvasRenderingContext2D;
  public contextTable: CanvasRenderingContext2D;
  loadingResults: Boolean = false;
  mapas = [];
  /**SHP Variables */
  public shpfileToUpload: File = null;
  public CargarShapefile: Boolean =  false;

  tab = document.createElement('div');

  ngOnInit() {
    //this.mapa(0);
    this.capas_select = [
    {value:"bioap:avc_1",label:"AVC 1",name:"avc_1",grupo:1,style:'',checked: "",description:"descripcion_avc1",info:[{label: "Manejo", codigo:"cmavc1"},{label: "Área AVC",codigo:"caavc1"},{label: "Área manejo",codigo:"cmaavc1"}],cob:"avc_1_encontrado"},
    {value:"bioap:avc_2",label:"AVC 2",name:"avc_2",grupo:1,style:'',checked: "",description:"descripcion_avc2",info:[{label: "Manejo", codigo:"cmavc2"},{label: "Área AVC",codigo:"caavc2"},{label: "Área manejo",codigo:"cmaavc2"}],cob:"avc_2_encontrado"},
    {value:"bioap:avc_3",label:"AVC 3",name:"avc_3",grupo:1,style:'',checked: "",description:"descripcion_avc3",info:[{label: "Manejo", codigo:"cmavc3"},{label: "Área AVC",codigo:"caavc3"},{label: "Área manejo",codigo:"cmaavc3"}],cob:"avc_3_encontrado"},
    {value:"bioap:avc_4",label:"AVC 4",name:"avc_4",grupo:1,style:'',checked: "",description:"descripcion_avc4",info:[{label: "Manejo", codigo:"cmavc4"},{label: "Área AVC",codigo:"caavc4"},{label: "Área manejo",codigo:"cmaavc4"}],cob:"avc_4_encontrado"},
    {value:"bioap:avc_5",label:"AVC 5",name:"avc_5",grupo:1,style:'',checked: "",description:"descripcion_av5",info:[{label: "Manejo", codigo:"cmavc5"},{label: "Área AVC",codigo:"caavc5"},{label: "Área manejo",codigo:"cmaavc5"}],cob:"avc_5_encontrado"},
    {value:"bioap:avc_6",label:"AVC 6",name:"avc_6",grupo:1,style:'',checked: "",description:"descripcion_av6",info:[{label: "Manejo", codigo:"cmavc6"},{label: "Área AVC",codigo:"caavc6"},{label: "Área manejo",codigo:"cmaavc6"}],cob:"avc_6_encontrado"},
    {value:"bioap:avc_coberturas",label:"AVC coberturas",name:"avc_coberturas",grupo:1,style:'',checked: "",description:"cdc",info:[],cob:"cobertura"},
    {value:"bioap:deforestacion_2013_2016",label:"Deforestacion 2013 - 2016",name:"deforestacion_2013_2016",grupo:1,style:'',checked: "",description:"",info:[],cob:"ano"},
    {value:"bioap:distribucion_potencial_anfibios",label:"DISTRIBUCION POTENCIAL ANFIBIOS",name:"Distribucion_potencial_anfibios",grupo:1,style:'',checked: "",description:"",info:[],cob:"genus_name"},
    {value:"bioap:distribucion_potencial_aves",label:"DISTRIBUCION POTENCIAL AVES",name:"Distribucion_potencial_aves",grupo:1,style:'',checked: "",description:"",info:[],cob:"genus_name"},
    {value:"bioap:distribucion_potencial_mamiferos",label:"DISTRIBUCION POTENCIAL MAMFEROS",name:"Distribucion_potencial_mamiferos",grupo:1,style:'',checked: "",description:"",info:[],cob:"genus_name"},
    {value:"bioap:distribucion_potencial_reptiles",label:"DISTRIBUCION POTENCIAL REPTILES",name:"Distribucion_potencial_reptiles",grupo:1,style:'',checked: "",description:"",info:[],cob:"genus_name"},
    {value:"bioap:lb_ecorregion",label:"LB Ecorregiones",name:"lb_ecorregiones",grupo:1,style:'',checked: "",description:"",info:[],cob:""},
    {value:"bioap:lb_hidrografia",label:"LB Hidrografia",name:"lb_hidrografia",grupo:1,style:'',checked: "",description:"",info:[],cob:""},
    {value:"bioap:lb_hotspot",label:"LB Hotspot",name:"lb_hotspot",grupo:1,style:'',checked: "",description:"",info:[],cob:""},
    {value:"bioap:lb_resguardos_indigenas",label:"LB Resguardos Indigenas",name:"lb_resguardos_indigenas",grupo:1,style:'',checked: "",description:"",info:[],cob:""},
    {value:"bioap:lb_suelos",label:"LB suelos",name:"lb_suelos",grupo:1,style:'',checked: "",description:"",info:[],cob:""}
    ];
  }

  mapa(id) {
    this.steepercontainer.nativeElement.style.display = 'none';
    this.geomcontainer.nativeElement.style.display = 'flex';
    var source = new VectorSource(); 
    var layerst = [];
    this.LayerBase = new TileLayer({
      visible: true,
      preload: Infinity,
      source: new BingMaps({
        key:
          "Ap0AObt84NcDaUThCeWOj52ZqUHv6k4TJhjLibR-DghC-semgoj-0uPbIi8r0E4j",
        imagerySet: "AerialWithLabelsOnDemand",
      })
    })
    this.LayerBase.set('name', 'CapaBase');
    if(id == 'SHP'){
      this.CargarShapefile = !this.CargarShapefile;
      this.source = new VectorSource({wrapX: false});
      this.vector = new VectorLayer();
      this.startMap("map");
    }else{
      this.source = new VectorSource({wrapX: false});
      this.vector = new VectorLayer({
      source: this.source,
      style: new Style({
        fill: new Fill({
          color: 'rgba(255, 255, 255, 0.2)'
        }),
        stroke: new Stroke({
          color: '#6E2C00',
          lineDash: [10, 10],
          width: 2
        }),
        image: new Circle({
          radius: 5,
          stroke: new Stroke({
            color: 'rgba(0, 0, 0, 0.7)'
          }),
          fill: new Fill({
            color: '#6E2C00'
          })
        })
      })
    });
    this.startMap("map");

    if(id == 'Point'){
        var value = GeometryType.POINT;
    }else if(id == 'Polygon'){
        var value = GeometryType.POLYGON;
    }else if(id == 'Line'){
        var value = GeometryType.LINE_STRING;
    }
    this.draw = new Draw({
          source: this.source,
          type: value,
          style: new Style({
            fill: new Fill({
              color: 'rgba(255, 255, 255, 0.2)'
            }),
            stroke: new Stroke({
              color: '#6E2C00',
              lineDash: [10, 10],
              width: 2
            }),
            image: new Circle({
              radius: 5,
              stroke: new Stroke({
                color: 'rgba(0, 0, 0, 0.7)'
              }),
              fill: new Fill({
                color: '#6E2C00'
              })
            })
          })
      });
      this.map.addInteraction(this.draw);
    }
  }

  startMap(map){
    var view = new View({
      center: transform([-74, 4], 'EPSG:4326', 'EPSG:3857'),
      zoom: 6,
    });
    // se hace push al objeto layers, el cual ya contiene toda la informacion de las capas bing maps

    if(map == "map"){
      this.map = new Map({
      controls: defaultControls().extend([
        new ScaleLine({
          units: "metric",
        })
      ]),
      layers:  [this.LayerBase, this.vector],
      target: "map",
      view: view,
      });
    }
  }
  Cancelar(){
    this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
      this.router.navigate(['dashboard/ecosistema-analisis']);
    });
  }
  BorrarGeom(){
    this.source.clear();
  }
  SelectLLayers(){
    const geom_type = this.source.getFeatures()[0].getGeometry().getType();
    if(geom_type == GeometryType.POLYGON){
      this.geomcontainer.nativeElement.style.display = 'none';
      this.Layercontainer.nativeElement.style.display = 'flex';
    }else{
      swal.fire({
        icon: "error",
        html: "Esta geometria requiere de un <b>Buffer</b> para poder continuar. Por favor ejecutelo con el botón en la barra inferior."
      })
    }
    
  }

  Analizar(){
    this.Layercontainer.nativeElement.style.display = 'none';
    this.resultcontainer.nativeElement.style.display = 'flex';
    this.procesamiento_wps()
  }

  async procesamiento_wps(){
    this.loadingResults = !this.loadingResults
    // trayendo la geomtria 
    let ol_geometry = this.source.getFeatures()[0].getGeometry();
    // transformando coordenadas
    ol_geometry.transform('EPSG:3857','EPSG:4326');
    // creando objeto wkt para el wps
    let format = new GeoJSON();
    let geojson_geom = JSON.parse(format.writeGeometry(ol_geometry));

    let ol_extent = ol_geometry.getExtent()

    const capas = this.capas_select.filter(item => item.checked == "t");
    let capas_body = capas.map(capa => {
      return {
        "name": capa.label,
        "id": capa.name
      }
    });


    for(let capa of capas_body){
      let body={}
      body["capa"] = capa
      body["aoi"] = geojson_geom
      let url = `${environment.backend_python}capas-aoi/`;
      await this.http.post(url,body).toPromise().then( geojson => {
        if(geojson && geojson["data"].geodata.features.length > 0){
          this.result_dataset.push(geojson["data"]);
        }
      })
    }
    //Funciones para creacion del mapa y dashboard
    await this.textoCapas(this.result_dataset);
    await this.map_content(this.result_dataset);
    await this.drawTable(this.result_dataset);
    await this.chart_builder(this.result_dataset);
    this.loadingResults = !this.loadingResults
    this.mapas = this.mapas
    this.text_layers.splice(-1,1);
  }

  chart_builder(data){
    for(let i in data){
      let input = this.chartDta(data[i]);
      this.canvas.forEach(element => console.log(element.nativeElement.id));
      let childrens = this.canvas._results;
      childrens.map((myCanvas, j) => {
        if(j==i){
          this.context = myCanvas.nativeElement.getContext('2d')
          this.text_layers[i].chart = new Chart(this.context, {
            type: 'doughnut',
            data: {
              labels: input.labels,
              datasets: [
                {
                  data: input.data,
                  backgroundColor: pallete('tol-rainbow', input.data.length).map(function(hex) {
                    return '#' + hex;
                  }),
                  fill: false,
                  hoverOffset:15
                }
              ]
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              cutoutPercentage: 60,
              legend: {
                        display: false
                      },
              animation: {
                        animateRotate: false
                      },
              tooltips:{
                callbacks: {
                  title: function (tooltipItems) {
                    return tooltipItems[0].formattedValue;
                  }
                },
                titleFontSize: 5,
                bodyFontSize: 10,
                boxWidth: 5
              },
              layout: {
                        padding: {
                            right: 25,
                            bottom: 25
                        }
                     }
            }
          });
        }
      });
    }
  }
  
  chartDta(data){
    let title = data.name
    let fila_capa = this.capas_select.filter(item => item.label == title);
    let cob = fila_capa[0].cob
    let datos = {}
    let geodata = data["geodata"].features
    for(let i in geodata){
      let datos_keys =  Object.keys(datos)
      let attribute_cob = geodata[i].properties[cob]
      let area = geodata[i].properties["areaha"]
      if(!datos_keys.includes(attribute_cob)){
        datos[attribute_cob] = area
      }else{
        datos[attribute_cob] += area
      }
    }
    let ChartDataset = {
      labels: Object.keys(datos),
      data: Object.values(datos)
    } 

    return ChartDataset
  }

  map_content(result){
    let maps = []
    for(var i in result){
      let geojson = result[i]["geodata"];
      let capa =  this.capas_select.find(item => item.name == result[i].id);
      
      if(capa && geojson && geojson.features.length > 0){
        const resultSource = new VectorSource({
          features: new GeoJSON({
            dataProjection: "EPSG:4326",
            featureProjection: "EPSG:3857"
          }).readFeatures(geojson),
        });
        const resultLayer = new VectorLayer({
          source: resultSource,
          style: new Style({
            stroke: new Stroke({
              color: 'red',
              lineDash: [4],
              width: 3,
            }),
            fill: new Fill({
              color: 'rgba(0, 0, 255, 0.1)',
            }),
          }),
        });

        var source_wms = new TileWMS({
          url: environment.geoserverBaseUrl + '/wms',
          params: {LAYERS: capa.value},
          serverType: 'geoserver',
        });
        var l = new TileLayer({
          visible: true,
          opacity: 0.2,
          //crossOrigin: 'anonymous',
          source: source_wms,
        });

        this[result[i].id] = new Map({
          layers:  [this.LayerBase,l,resultLayer],
          target: result[i].id,
          view: new View({
            center: transform([-74, 4], 'EPSG:4326', 'EPSG:3857'),
            zoom: 10,
          }),
        });
        // this.mapa2 = this[result[i].id]
        if(result[i]["geodata"].features.length != 0){
          // Define the padding in pixels
          const padding = 200;

          // Get the extent from resultSource
          const extent = resultSource.getExtent();

          // Calculate the padded extent
          const paddedExtent = [
            extent[0] - padding, // left
            extent[1] - padding, // bottom
            extent[2] + padding, // right
            extent[3] + padding  // top
          ];
          this[result[i].id].getView().fit(paddedExtent, this[result[i].id].getSize());
          this[result[i].id].getView().setZoom(this[result[i].id].getView().getZoom());
        }
        maps.push(this[result[i].id])
      }
    }
    this.mapas = maps
  }

  selectAll(t){
    var text = t;
    for(var i=0; i < this.capas_select.length; i++) {
         this.capas_select[i].checked = text;
    }
  }

  toggleCheckbox(event, id){
    if(event.target.checked == true){
      this.capas_select.find(item => item.value == id).checked = "t";
    }else{
      this.capas_select.find(item => item.value == id).checked = "";
    }    
  }
  /** suubiendo GEOJSON al mapa */
  importGeoJsonToMap(geojson){
    this.source = new VectorSource({
      features: new GeoJSON().readFeatures(geojson,{
        dataProjection: 'EPSG:4326', //geojson projection
        featureProjection:'EPSG:3857', //view projection
        })
    });
    var vectorLayer = new VectorLayer({
      source: this.source
    });
    this.map.addLayer(vectorLayer);
    this.map.getView().fit(this.source.getExtent(), this.map.getSize());
  }

  /** Subiendo archivo SHP y convirtiendolo a GEOJSON  */
  async uploadshp(file:File){
    let  geojson_;
    let geojson_shp = this.geojson_shp
    await this.mapservice.readFileContent(file)
      .toPromise().then(
        res => {
          geojson_ = res;
          shp(geojson_).then(function(geo){
            //importMap(geo);
            geojson_shp = geo
          })
        }
      )
    setTimeout(()=>{
      try{
        this.importGeoJsonToMap(geojson_shp)
      }catch(error){
        swal.fire({
          icon: "error",
          html: "Revisar el Archivo, parece estar corrupto"
        })
      }
      
    },1000)
  }
  /** Lee el archivo y lo envía a la función uploadshop  */
  inputshp(files){
    this.shpfileToUpload = files[0];
    this.uploadshp(this.shpfileToUpload);
  }

  /** Ventana para ingredo de valores del Buffer */
  async BufferGeom(){

    let {value: buffer} = await swal.fire({
      title: "Distancia en Buffer",
      html: "Ingrese la distancia de area de influencia en <b>metros<b>",
      input : "number",
      inputPlaceholder: "Distancia en metros",
      showCancelButton: true,
    })

    if (buffer > 0) {
      this.procesoBuffer(buffer);
    }else{
      swal.fire(`Valor no tiene sentido debe ser mayor a cero`)
    }
  }

    /** Proceso de Buffer */
  procesoBuffer(distancia:number){

      /** Inicializar el jst */
      const parser = new jsts.io.OL3Parser();
      /** Habiitar las Geometrias */
      parser.inject(
        Point,
        LineString,
        LinearRing,
        Polygon,
        MultiPoint,
        MultiLineString,
        MultiPolygon
      );

      /** leer las geomtrias desde el source desde el AOI */
      let features = this.source.getFeatures();

      for (let i = 0; i < features.length; i++) {
        const feature = features[i];
        // convertir la geometria en jsts
        const jstsGeom = parser.read(feature.getGeometry());

        // Creacion del buffer
        const buffered = jstsGeom.buffer(distancia);

        // cambiar la geometria del source
        feature.setGeometry(parser.write(buffered));
      }

      this.source.clear()
      this.source.addFeatures(features);

      let vectorLayer_ = new VectorLayer({
        source: this.source,
      });

      this.map.addLayer(vectorLayer_);
  }

  drawTable(results){
    for(let k in results){
      let data = results[k].geodata
      let capa =  this.capas_select.find(item => item.name == results[k].id);
      if(capa){
        /*Organizing Table*/
        let datos = [];
        for (var i=0; i<data.features.length; i++){
              datos.push(Object.assign({Contador:i+1, Capa:results[k].id, geom:data.features[i] },data.features[i].properties));
        }
        let childrens = this.table._results;
        let mapas = this.mapas
        this.table.map((mydiv, j) => {
          console.log(mydiv)
          if(j==k){
            this.contextTable = mydiv.nativeElement;
            new Tabulator(this.contextTable, {
              data: datos,
              columns:[
                {title: "ID", field: "Contador"},
                {title: "Item", field: capa.cob},
                {title: "Area Ha", field: "areaha"}
              ],
              keybidings:false,
              columnMinWidth:100,
              layout:"fitColumns",
              height: this.height,
              tooltips:true,     
              movableColumns:true,      //allow column order to be changed
              resizableRows:true,
              selectable:1,
              rowClick:function(e,row){
                console.log(row)
                let id = row._row.data.Capa
                let vectorSource = new VectorSource({
                  features: new GeoJSON({
                    dataProjection: "EPSG:4326",
                    featureProjection: "EPSG:3857"
                  }).readFeatures(row._row.data.geom),
                });
                let vectorLayer = new VectorLayer({
                  source: vectorSource,
                  style: new Style({
                    stroke: new Stroke({
                      color: 'blue',
                      lineDash: [4],
                      width: 3,
                    }),
                    fill: new Fill({
                      color: 'rgba(0, 0, 255, 0.1)',
                    }),
                  })
                });
                vectorLayer.set("name","seleccion")
                for(let m in mapas){
                  if(mapas[m].getTarget() == id){
                    console.log("son iguales")
                    mapas[m].getLayers().forEach(function (layer) {
                      if (layer.get('name') != undefined && layer.get('name') === 'seleccion') {
                        mapas[m].removeLayer(layer);
                      }
                    });
                    mapas[m].addLayer(vectorLayer);
                    mapas[m].getView().fit(vectorSource.getExtent(), mapas[m].getSize());
                  }
                }
              },
            });
          }
          });
      }
      }
    
  }

  async textoCapas(result){
    console.log(result)
    for(let i in result){
      let feature_id = result[i].id
      let title = result[i].name
      let fila_capa = this.capas_select.filter(item => item.label == title);
      let desctiptor;
      try{
        await this.descriptiorTexto(result[i]["geodata"], fila_capa[0].description,fila_capa[0].info,fila_capa[0].cob).then((result)=>{ return desctiptor = result})
        this.text_layers.push({name: title, text:desctiptor, id: feature_id, chart: "", table:""})
      }catch(e){
        this.text_layers.push({name: "", text:"", id:"", chart: "", table:""})
      } 
    }
  }

  async descriptiorTexto(dta, descript, ArrInf,cobertura){
    let data = dta.features;
    let ArrayText = [];
    let domain = []
    for(let i in data){
      let validator = domain.includes(data[i].properties[cobertura])
      if(!validator){
        let cobertura_name = data[i].properties[cobertura]
        let Description;
        await this.getTablaDominios(data[i].properties[descript]).then((result) =>{return Description = result})
        let information;
        await this.infoText(data[i],ArrInf).then((result) =>{return information = result})
        ArrayText.push({cob:cobertura_name, descripcion: Description, info:information})
        domain.push(cobertura_name)
      }
    }
    return ArrayText
  }

  async infoText(data,ArrInfo){
    let arrTextInfo = []
    for(let i in ArrInfo){
      let label_info = ArrInfo[i].label
      let cod = data.properties[ArrInfo[i].codigo]
      let text_info;
      await this.getTablaDominios(cod).then((result) =>{return text_info = result})
      arrTextInfo.push({label: label_info, text: text_info})
    }
    return arrTextInfo
  }

  async getTablaDominios(codigo) : Promise<string>{
    let url = `${environment.geoserverBaseUrl}/bioap/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=bioap:tabla_dominios_bd&CQL_FILTER=id_dom IN ('${codigo}')&outputFormat=application%2Fjson`;
    const fetchResult = fetch(`${url}`)
    const response = await fetchResult
    let jsonData = await response.json();
    jsonData = JSON.parse(jsonData.contents)
    if(jsonData.totalFeatures > 0){
      const result = jsonData.features[0].properties.descripcion
      return result
    }else{
      return ""
    }
  }

}
